import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.logistics-vehicle')
  .factory('$logisticsVehicleLocation', LogisticsVehicleLocationObjectFactory);

/* @ngInject */
function LogisticsVehicleLocationObjectFactory($bringozFactory: $bringozFactory,
                                               LogisticsVehicleLocationAPI: BringozApi,
                                               LogisticsVehicleLocation_DS: DataStoreConfig,
                                               LogisticsVehicleLocation_PN: PushNotificationsConfig) {

  function $logisticsVehicleLocation(id: string) {
    return $bringozFactory(id, LogisticsVehicleLocationAPI, LogisticsVehicleLocation_DS, LogisticsVehicleLocation_PN);
  }

  return $logisticsVehicleLocation;
}
